'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var reactI18next = require('react-i18next');
var Validator = require('../alloy-input/Validator.js');
var useDefaultInternalState = require('../../hooks/useDefaultInternalState.js');
var DatePicker = require('./DatePicker.js');
var datePicker_module = require('./date-picker.module.scss.js');
var FieldRequiredIndicator = require('../alloy-input/FieldRequiredIndicator.js');

var DateRangePicker = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, id = _a.id, label = _a.label, locale = _a.locale, setValue = _a.setValue, showRequired = _a.showRequired, showOptional = _a.showOptional, _c = _a.value, value = _c === void 0 ? {} : _c, _d = _a.startDateProps, startDateProps = _d === void 0 ? {} : _d, _e = _a.endDateProps, endDateProps = _e === void 0 ? {} : _e, _f = _a.commonProps, commonProps = _f === void 0 ? {} : _f, required = _a.required, _g = _a.error, error = _g === void 0 ? {} : _g, setError = _a.setError, onBlur = _a.onBlur;
    var t = reactI18next.useTranslation()[0];
    var _h = useDefaultInternalState.default(value, setValue), valueState = _h[0], setValueState = _h[1];
    var _j = useDefaultInternalState.default(error, setError), errorState = _j[0], setErrorState = _j[1];
    var validate = function (values) {
        if (values === void 0) { values = valueState; }
        var startError = '';
        var endError = '';
        //TODO: will be take care while migration of Alloy Input Story
        var error = new Validator.default(values)
            .isValidRangeDates(t('OH_FILTER_GREATER_THAN_END'))
            .getError();
        endError = error;
        startError = error;
        if (required) {
            //TODO: will be take care while migration of Alloy Input Story
            startError =
                new Validator.default(values.start)
                    .required(t('REQUIRED_FIELD_ENTER'))
                    .getError() || startError;
            //TODO: will be take care while migration of Alloy Input Story
            endError =
                new Validator.default(values.end)
                    .required(t('REQUIRED_FIELD_ENTER'))
                    .getError() || endError;
        }
        setErrorState({ startError: startError, endError: endError });
    };
    var handleBlur = function (e) {
        validate();
        if (onBlur) {
            onBlur(e);
        }
    };
    var handleStartDateChange = function (newStartDate) {
        var newState = tslib.__assign(tslib.__assign({}, valueState), { start: newStartDate });
        setValueState(newState);
        validate(newState);
    };
    var handleEndDateChange = function (newEndDate) {
        var newState = tslib.__assign(tslib.__assign({}, valueState), { end: newEndDate });
        setValueState(newState);
        validate(newState);
    };
    return (jsxRuntime.jsxs("fieldset", tslib.__assign({ className: "date-range-picker ".concat(className) }, { children: [label && (jsxRuntime.jsxs("legend", tslib.__assign({ className: "".concat(datePicker_module.default['date-picker__label']) }, { children: [label, jsxRuntime.jsx(FieldRequiredIndicator.default, { showRequired: showRequired, showOptional: showOptional })] }))), jsxRuntime.jsxs("div", tslib.__assign({ id: id, className: "input-group flex-nowrap" }, { children: [jsxRuntime.jsx(DatePicker.default, tslib.__assign({ id: "".concat(id, "start"), label: "Start Date", hideLabel: true, selectsStart: true, date: valueState.start, setDate: handleStartDateChange, error: errorState.startError, setError: function () { return undefined; }, startDate: valueState.start, endDate: valueState.end, todayButton: t('TODAY'), locale: locale, className: "w-100", onBlur: handleBlur }, startDateProps, commonProps)), jsxRuntime.jsx("div", tslib.__assign({ className: "".concat(datePicker_module.default['date-picker__dash']) }, { children: "\u2013" })), jsxRuntime.jsx(DatePicker.default, tslib.__assign({ id: "".concat(id, "end"), label: "End Date", hideLabel: true, selectsEnd: true, date: valueState.end, setDate: handleEndDateChange, error: errorState.endError, setError: function () { return undefined; }, startDate: valueState.start, endDate: valueState.end, minDate: valueState.start, todayButton: t('TODAY'), locale: locale, className: "w-100", onBlur: handleBlur }, endDateProps, commonProps))] }))] })));
};
var DateRangePicker$1 = DateRangePicker;

exports.default = DateRangePicker$1;
//# sourceMappingURL=DateRangePicker.js.map
